import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {environment} from './environments/environment';
import {enableAkitaProdMode, persistState} from '@datorama/akita';
import * as localForage from 'localforage';
import {debounceTime} from "rxjs/operators";
import {MetecImeModule} from "./app/metec-ime.module";
import {convertToClassObjects} from "ime-shared";

localForage.config({
  driver: localForage.INDEXEDDB,
  name: 'Akita',
  version: 1.0,
  storeName: 'akitaDb'
});

const storage = persistState({
  storage: localForage, include: [storeName => {
    return ['unit', 'language', 'property', 'user', 'ClassificatorValue', 'CostPriceComponent', 'Classificator', 'Item', 'ItemGroup', 'resource'].includes(storeName);
  }],
  preStorageUpdateOperator: () => debounceTime(2000),
  preStorageUpdate(storeName, state) {
    return state;
  },
  preStoreUpdate(storeName: string, state: any): any {
    return convertToClassObjects(storeName, state);
  }
});

const providers = [
  {
    provide: 'persistStorage', useValue: storage
  }
];

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(MetecImeModule)
  .catch(err => console.error(err));
